import { useEffect, useState } from 'react';

/**
 * Send the user back to the client with their refresh token, once both are known.
 *
 * The token and the validated redirect URL arrive independently: the lookup can still be retrying
 * when a login succeeds, and `/v3` checks the stored token while the lookup is in flight. Holding
 * the token until the URL is known means a fast login cannot navigate to `undefined?refresh-token=`.
 */
const useRedirectBack = (
  redirectUrl: string | undefined,
  nonce: string | null
) => {
  const [token, setToken] = useState<string>();

  useEffect(() => {
    if (!redirectUrl || !token) {
      return;
    }

    const urlParams = new URLSearchParams();
    urlParams.set('refresh-token', token);
    urlParams.set('nonce', nonce || '');
    window.location.replace(`${redirectUrl}?${urlParams.toString()}`);
  }, [redirectUrl, token, nonce]);

  return setToken;
};

export default useRedirectBack;
